"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Validator = exports.ValidatorKeys = void 0;
const Validation_1 = require("./Validation");
// prettier-ignore
var ValidatorKeys;
(function (ValidatorKeys) {
    ValidatorKeys["instanceOf"] = "invalid instanceof";
    ValidatorKeys["definedNotNull"] = "undefined or null";
    ValidatorKeys["truthy"] = "not truthy";
    ValidatorKeys["defined"] = "typeof is undefined";
    ValidatorKeys["min"] = "does not meet the min requirement";
    ValidatorKeys["quantityMin"] = "does not meet the min requirement";
    ValidatorKeys["max"] = "does not meet the max requirement";
    ValidatorKeys["quantityMax"] = "does not meet the max requirement";
    ValidatorKeys["range"] = "does not meet the range requirement";
    ValidatorKeys["quantityRange"] = "does not meet the range requirement";
    ValidatorKeys["bigger"] = "not bigger than";
    ValidatorKeys["quantityBigger"] = "not bigger than";
    ValidatorKeys["smaller"] = "not smaller than";
    ValidatorKeys["quantitySmaller"] = "not smaller than";
    ValidatorKeys["identical"] = "not identical entity";
})(ValidatorKeys = exports.ValidatorKeys || (exports.ValidatorKeys = {}));
/**
 * The `Validator` has the responsibility to
 * perform validations.
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
class Validator {
    /**
     * Validates if anything is instanceof a dedicated type.
     *
     * @param anything The value to validate
     * @param instanceType The type to validate
     * @param [key=ValidatorKeys.instanceOf] If caller (e.g. higher validator) wants to overwrite the
     * key
     * @returns The validator
     */
    static instanceOf(anything, instanceType, key = ValidatorKeys.instanceOf) {
        return Validation_1.Validation.create(anything instanceof instanceType, key);
    }
    /**
     * Validates if arg is defined.
     *
     * @param anything The value to validate
     * @param [key=ValidatorKeys.defined] If caller (e.g. higher validator) wants to overwrite the
     * key
     * @returns The validator
     */
    static defined(anything, key = ValidatorKeys.defined) {
        return Validation_1.Validation.create(typeof anything !== 'undefined', key);
    }
    /**
     * Validates if value is defined and not null.
     *
     * @param value The value to validate
     * @param [key=ValidatorKeys.definedNotNull] If caller (e.g. higher validator) wants to overwrite
     * the key
     * @returns The validator
     */
    static definedNotNull(value, key = ValidatorKeys.definedNotNull) {
        return Validation_1.Validation.create(value != null, key);
    }
    /**
     * Validates if value is truthy.
     *
     * @param value The value to validate
     * @param [key=ValidatorKeys.truthy] If caller (e.g. higher validator) wants to overwrite
     * the key
     * @returns The validator
     */
    static truthy(value, key = ValidatorKeys.truthy) {
        return Validation_1.Validation.create(!!value, key);
    }
    /**
     * Validates if value is of type number and minimum a given value.
     *
     * @param value The value to validate
     * @param min The minimum allowed value
     * @param [key=ValidatorKeys.min] If caller (e.g. higher validator) wants to overwrite
     * the key
     * @returns The validator
     */
    static min(value, min, key = ValidatorKeys.min) {
        return Validation_1.Validation.create(typeof value === 'number' && value >= min, key);
    }
    /**
     * Validates if value is of type number and minimum a given value.
     *
     * @param obj The quantity object to validate
     * @param unit The quantity object's unit to validate
     * @param min The minimum allowed value
     * @param [key=ValidatorKeys.quantityMin] If caller (e.g. higher validator) wants to overwrite
     * the key
     * @returns The validator
     */
    static quantityMin(obj, unit, min, key = ValidatorKeys.quantityMin) {
        return Validation_1.Validation.create((obj != null || obj !== undefined) &&
            unit in obj &&
            typeof obj[unit] === 'number' &&
            obj[unit] >= min, key);
    }
    /**
     * Validates if value is of type number and maximal of given value.
     *
     * @param value The value to validate
     * @param max The maximum allowed value
     * @param [key=ValidatorKeys.max] If caller (e.g. higher validator) wants to overwrite
     * the key
     * @returns The validator
     */
    static max(value, max, key = ValidatorKeys.max) {
        return Validation_1.Validation.create(typeof value === 'number' && value <= max, key);
    }
    /**
     * Validates if value is of type number and maximal of given value.
     *
     * @param obj The quantity object to validate
     * @param unit The quantity object's unit to validate
     * @param max The maximum allowed value
     * @param [key=ValidatorKeys.quantityMax] If caller (e.g. higher validator) wants to overwrite
     * the key
     * @returns The validator
     */
    static quantityMax(obj, unit, max, key = ValidatorKeys.quantityMax) {
        return Validation_1.Validation.create((obj != null || obj !== undefined) &&
            unit in obj &&
            typeof obj[unit] === 'number' &&
            obj[unit] <= max, key);
    }
    static range(value, min, max, key = ValidatorKeys.range) {
        return Validation_1.Validation.create(typeof value === 'number' && value >= min && value <= max, key);
    }
    static quantityRange(obj, unit, min, max, key = ValidatorKeys.quantityRange) {
        return Validation_1.Validation.create((obj != null || obj !== undefined) &&
            unit in obj &&
            typeof obj[unit] === 'number' &&
            obj[unit] <= max &&
            obj[unit] >= min, key);
    }
    /**
     * Validates if value is of type number and bigger than given argument.
     *
     * @param value The value to validate
     * @param min The minimum not allowed value
     * @param [key=ValidatorKeys.bigger] If caller (e.g. higher validator) wants to overwrite
     * the key
     * @returns The validator
     */
    static bigger(value, min, key = ValidatorKeys.bigger) {
        return Validation_1.Validation.create(typeof value === 'number' && value > min, key);
    }
    /**
     * Validates if value is of type number and bigger than given argument.
     *
     * @param obj The quantity object to validate
     * @param unit The quantity object's unit to validate
     * @param min The minimum not allowed value
     * @param [key=ValidatorKeys.quantityBigger] If caller (e.g. higher validator) wants to overwrite
     * the key
     * @returns The validator
     */
    static quantityBigger(obj, unit, min, key = ValidatorKeys.quantityBigger) {
        return Validation_1.Validation.create((obj != null || obj !== undefined) &&
            unit in obj &&
            typeof obj[unit] === 'number' &&
            obj[unit] > min, key);
    }
    /**
     * Validates if value is of type number and smaller than given argument.
     *
     * @param value The value to validate
     * @param max The maximum not allowed value
     * @param [key=ValidatorKeys.smaller] If caller (e.g. higher validator) wants to overwrite
     * the key
     * @returns The validator
     */
    static smaller(value, max, key = ValidatorKeys.smaller) {
        return Validation_1.Validation.create(typeof value === 'number' && value < max, key);
    }
    /**
     * Validates if value is of type number and smaller than given argument.
     *
     * @param obj The quantity object to validate
     * @param unit The quantity object's unit to validate
     * @param max The maximum not allowed value
     * @param [key=ValidatorKeys.quantitySmaller] If caller (e.g. higher validator) wants to overwrite
     * the key
     * @returns The validator
     */
    static quantitySmaller(obj, unit, max, key = ValidatorKeys.quantitySmaller) {
        return Validation_1.Validation.create((obj != null || obj !== undefined) &&
            unit in obj &&
            typeof obj[unit] === 'number' &&
            obj[unit] < max, key);
    }
    /**
     * Validates if given objects are identical.
     *
     * @param item1 The item to check
     * @param item2 The other item to check
     * @param [key=ValidatorKeys.identical] If caller (e.g. higher validator) wants to overwrite
     * the key
     * @returns The validator result
     */
    static identical(item1, item2, key = ValidatorKeys.identical) {
        return Validation_1.Validation.create(item1 === item2, key);
    }
}
exports.Validator = Validator;
//# sourceMappingURL=Validator.js.map